var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row container-stats" }, [
    _c(
      "div",
      { staticClass: "col-4 stats" },
      [
        _c("b-card", { staticClass: "earnings-card" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("b-card-title", { staticClass: "mb-1" }, [
                  _vm._v(" Tiempo máximo ")
                ]),
                _c("h5", { staticClass: "mb-1" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("timeApprovals")(
                          _vm.resume.maxMinutosTranscurridosEjecucion
                        )
                      ) +
                      " "
                  )
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-auto text-center" },
              [
                _c(
                  "b-avatar",
                  { attrs: { size: "48", variant: "light-danger" } },
                  [
                    _c("feather-icon", {
                      attrs: { size: "34", icon: "AlertCircleIcon" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-4 stats" },
      [
        _c("b-card", { staticClass: "earnings-card" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("b-card-title", { staticClass: "mb-1" }, [
                  _vm._v(" Tiempo Mínimo ")
                ]),
                _c("h5", { staticClass: "mb-1" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("timeApprovals")(
                          _vm.resume.minMinutosTranscurridosEjecucion
                        )
                      ) +
                      " "
                  )
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-auto text-center" },
              [
                _c(
                  "b-avatar",
                  { attrs: { size: "48", variant: "light-success" } },
                  [
                    _c("feather-icon", {
                      attrs: { size: "34", icon: "AwardIcon" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-4 stats" },
      [
        _c("b-card", { staticClass: "earnings-card" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("b-card-title", { staticClass: "mb-1" }, [
                  _vm._v(" Tiempo promedio ")
                ]),
                _c("h5", { staticClass: "mb-1" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("timeApprovals")(
                          _vm.resume.avgMinutosTranscurridosEjecucion
                        )
                      ) +
                      " "
                  )
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-auto text-center" },
              [
                _c(
                  "b-avatar",
                  { attrs: { size: "48", variant: "light-info" } },
                  [
                    _c("feather-icon", {
                      attrs: { size: "34", icon: "ClockIcon" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }